var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 150,
    viewBox: "0 0 230 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12313_361909)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.152 0H51.0751C45.1805 0 40.402 4.79695 40.402 10.7143V139.286C40.402 145.203 45.1805 150 51.0751 150H179.152C185.047 150 189.825 145.203 189.825 139.286V10.7143C189.825 4.79695 185.047 0 179.152 0Z",
    fill: "#F3F2F1"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_12313_361909)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.401 56H208.693C210.1 56 211.45 56.5644 212.446 57.5691C213.441 58.5737 214 59.9363 214 61.3571V88.1429C214 89.5637 213.441 90.9263 212.446 91.9309C211.45 92.9356 210.1 93.5 208.693 93.5H65.401C63.9934 93.5 62.6436 92.9356 61.6483 91.9309C60.653 90.9263 60.0939 89.5637 60.0939 88.1429V61.3571C60.0939 59.9363 60.653 58.5737 61.6483 57.5691C62.6436 56.5644 63.9934 56 65.401 56V56Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M132.946 64.8636H105.349C103.59 64.8636 102.165 66.3027 102.165 68.0779C102.165 69.8531 103.59 71.2922 105.349 71.2922H132.946C134.705 71.2922 136.13 69.8531 136.13 68.0779C136.13 66.3027 134.705 64.8636 132.946 64.8636Z",
    fill: "#C7E0F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.052 78.7921H105.349C103.59 78.7921 102.165 80.2312 102.165 82.0064C102.165 83.7816 103.59 85.2207 105.349 85.2207H152.052C153.81 85.2207 155.236 83.7816 155.236 82.0064C155.236 80.2312 153.81 78.7921 152.052 78.7921Z",
    fill: "#F3F2F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5739 87.8508C88.6083 87.8508 94.3109 82.0944 94.3109 74.9936C94.3109 67.8928 88.6083 62.1365 81.5739 62.1365C74.5394 62.1365 68.8368 67.8928 68.8368 74.9936C68.8368 82.0944 74.5394 87.8508 81.5739 87.8508Z",
    fill: "#2B88D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7754 77.627C80.7402 77.5293 80.709 77.4023 80.6816 77.2461C80.6543 77.0898 80.6406 76.9355 80.6406 76.7832C80.6406 76.5449 80.6875 76.3301 80.7812 76.1387C80.8789 75.9434 80.998 75.7617 81.1387 75.5938C81.2832 75.4258 81.4375 75.2637 81.6016 75.1074C81.7695 74.9512 81.9238 74.7988 82.0645 74.6504C82.209 74.502 82.3281 74.3457 82.4219 74.1816C82.5195 74.0176 82.5684 73.8379 82.5684 73.6426C82.5684 73.4668 82.5332 73.3145 82.4629 73.1855C82.3926 73.0527 82.2949 72.9434 82.1699 72.8574C82.0488 72.7676 81.9082 72.7012 81.748 72.6582C81.5918 72.6152 81.4238 72.5938 81.2441 72.5938C80.6621 72.5938 80.1074 72.8535 79.5801 73.373V72.0195C80.2207 71.6445 80.8848 71.457 81.5723 71.457C81.8887 71.457 82.1875 71.498 82.4688 71.5801C82.75 71.6621 82.9961 71.7832 83.207 71.9434C83.418 72.1035 83.584 72.3027 83.7051 72.541C83.8262 72.7793 83.8867 73.0566 83.8867 73.373C83.8867 73.6738 83.8359 73.9414 83.7344 74.1758C83.6328 74.4102 83.5039 74.627 83.3477 74.8262C83.1953 75.0215 83.0293 75.1953 82.8496 75.3477C82.6738 75.5 82.5078 75.6523 82.3516 75.8047C82.1992 75.957 82.0723 76.1152 81.9707 76.2793C81.8691 76.4434 81.8184 76.625 81.8184 76.8242C81.8184 76.9922 81.8398 77.1445 81.8828 77.2812C81.9258 77.418 81.9688 77.5332 82.0117 77.627H80.7754ZM81.4434 80.1055C81.2207 80.1055 81.0234 80.0293 80.8516 79.877C80.6875 79.7285 80.6055 79.5449 80.6055 79.3262C80.6055 79.1035 80.6875 78.9199 80.8516 78.7754C81.0195 78.6191 81.2168 78.541 81.4434 78.541C81.666 78.541 81.8613 78.6191 82.0293 78.7754C82.1934 78.9199 82.2754 79.1035 82.2754 79.3262C82.2754 79.5449 82.1934 79.7285 82.0293 79.877C81.8574 80.0293 81.6621 80.1055 81.4434 80.1055Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_12313_361909)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3071 102.75H163.599C165.007 102.75 166.356 103.314 167.352 104.319C168.347 105.324 168.906 106.686 168.906 108.107V134.893C168.906 136.314 168.347 137.676 167.352 138.681C166.356 139.686 165.007 140.25 163.599 140.25H20.3071C18.8996 140.25 17.5497 139.686 16.5544 138.681C15.5591 137.676 15 136.314 15 134.893V108.107C15 106.686 15.5591 105.324 16.5544 104.319C17.5497 103.314 18.8996 102.75 20.3071 102.75Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M86.7908 111.614H59.1938C57.4352 111.614 56.0095 113.053 56.0095 114.828C56.0095 116.603 57.4352 118.042 59.1938 118.042H86.7908C88.5494 118.042 89.975 116.603 89.975 114.828C89.975 113.053 88.5494 111.614 86.7908 111.614Z",
    fill: "#C7E0F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.896 125.542H59.1938C57.4352 125.542 56.0095 126.981 56.0095 128.756C56.0095 130.532 57.4352 131.971 59.1938 131.971H105.896C107.655 131.971 109.081 130.532 109.081 128.756C109.081 126.981 107.655 125.542 105.896 125.542Z",
    fill: "#F3F2F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.167 134.601C42.2015 134.601 47.904 128.844 47.904 121.744C47.904 114.643 42.2015 108.886 35.167 108.886C28.1325 108.886 22.4299 114.643 22.4299 121.744C22.4299 128.844 28.1325 134.601 35.167 134.601Z",
    fill: "#2B88D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7754 123.627C33.7402 123.529 33.709 123.402 33.6816 123.246C33.6543 123.09 33.6406 122.936 33.6406 122.783C33.6406 122.545 33.6875 122.33 33.7812 122.139C33.8789 121.943 33.998 121.762 34.1387 121.594C34.2832 121.426 34.4375 121.264 34.6016 121.107C34.7695 120.951 34.9238 120.799 35.0645 120.65C35.209 120.502 35.3281 120.346 35.4219 120.182C35.5195 120.018 35.5684 119.838 35.5684 119.643C35.5684 119.467 35.5332 119.314 35.4629 119.186C35.3926 119.053 35.2949 118.943 35.1699 118.857C35.0488 118.768 34.9082 118.701 34.748 118.658C34.5918 118.615 34.4238 118.594 34.2441 118.594C33.6621 118.594 33.1074 118.854 32.5801 119.373V118.02C33.2207 117.645 33.8848 117.457 34.5723 117.457C34.8887 117.457 35.1875 117.498 35.4688 117.58C35.75 117.662 35.9961 117.783 36.207 117.943C36.418 118.104 36.584 118.303 36.7051 118.541C36.8262 118.779 36.8867 119.057 36.8867 119.373C36.8867 119.674 36.8359 119.941 36.7344 120.176C36.6328 120.41 36.5039 120.627 36.3477 120.826C36.1953 121.021 36.0293 121.195 35.8496 121.348C35.6738 121.5 35.5078 121.652 35.3516 121.805C35.1992 121.957 35.0723 122.115 34.9707 122.279C34.8691 122.443 34.8184 122.625 34.8184 122.824C34.8184 122.992 34.8398 123.145 34.8828 123.281C34.9258 123.418 34.9688 123.533 35.0117 123.627H33.7754ZM34.4434 126.105C34.2207 126.105 34.0234 126.029 33.8516 125.877C33.6875 125.729 33.6055 125.545 33.6055 125.326C33.6055 125.104 33.6875 124.92 33.8516 124.775C34.0195 124.619 34.2168 124.541 34.4434 124.541C34.666 124.541 34.8613 124.619 35.0293 124.775C35.1934 124.92 35.2754 125.104 35.2754 125.326C35.2754 125.545 35.1934 125.729 35.0293 125.877C34.8574 126.029 34.6621 126.105 34.4434 126.105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_12313_361909)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.599 9.75H20.3071C17.3761 9.75 15 12.1485 15 15.1071V41.8929C15 44.8515 17.3761 47.25 20.3071 47.25H163.599C166.53 47.25 168.906 44.8515 168.906 41.8929V15.1071C168.906 12.1485 166.53 9.75 163.599 9.75Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.8522 18.6136H60.2552C58.4966 18.6136 57.0709 20.0527 57.0709 21.8279C57.0709 23.6031 58.4966 25.0422 60.2552 25.0422H87.8522C89.6108 25.0422 91.0364 23.6031 91.0364 21.8279C91.0364 20.0527 89.6108 18.6136 87.8522 18.6136Z",
    fill: "#C7E0F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.958 32.5425H60.2552C58.4966 32.5425 57.0709 33.9816 57.0709 35.7568C57.0709 37.532 58.4966 38.9711 60.2552 38.9711H106.958C108.716 38.9711 110.142 37.532 110.142 35.7568C110.142 33.9816 108.716 32.5425 106.958 32.5425Z",
    fill: "#F3F2F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2284 41.6006C43.2629 41.6006 48.9655 35.8443 48.9655 28.7435C48.9655 21.6427 43.2629 15.8864 36.2284 15.8864C29.1939 15.8864 23.4913 21.6427 23.4913 28.7435C23.4913 35.8443 29.1939 41.6006 36.2284 41.6006Z",
    fill: "#2B88D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1094 30.627C35.0742 30.5293 35.043 30.4023 35.0156 30.2461C34.9883 30.0898 34.9746 29.9355 34.9746 29.7832C34.9746 29.5449 35.0215 29.3301 35.1152 29.1387C35.2129 28.9434 35.332 28.7617 35.4727 28.5938C35.6172 28.4258 35.7715 28.2637 35.9355 28.1074C36.1035 27.9512 36.2578 27.7988 36.3984 27.6504C36.543 27.502 36.6621 27.3457 36.7559 27.1816C36.8535 27.0176 36.9023 26.8379 36.9023 26.6426C36.9023 26.4668 36.8672 26.3145 36.7969 26.1855C36.7266 26.0527 36.6289 25.9434 36.5039 25.8574C36.3828 25.7676 36.2422 25.7012 36.082 25.6582C35.9258 25.6152 35.7578 25.5938 35.5781 25.5938C34.9961 25.5938 34.4414 25.8535 33.9141 26.373V25.0195C34.5547 24.6445 35.2188 24.457 35.9062 24.457C36.2227 24.457 36.5215 24.498 36.8027 24.5801C37.084 24.6621 37.3301 24.7832 37.541 24.9434C37.752 25.1035 37.918 25.3027 38.0391 25.541C38.1602 25.7793 38.2207 26.0566 38.2207 26.373C38.2207 26.6738 38.1699 26.9414 38.0684 27.1758C37.9668 27.4102 37.8379 27.627 37.6816 27.8262C37.5293 28.0215 37.3633 28.1953 37.1836 28.3477C37.0078 28.5 36.8418 28.6523 36.6855 28.8047C36.5332 28.957 36.4062 29.1152 36.3047 29.2793C36.2031 29.4434 36.1523 29.625 36.1523 29.8242C36.1523 29.9922 36.1738 30.1445 36.2168 30.2812C36.2598 30.418 36.3027 30.5332 36.3457 30.627H35.1094ZM35.7773 33.1055C35.5547 33.1055 35.3574 33.0293 35.1855 32.877C35.0215 32.7285 34.9395 32.5449 34.9395 32.3262C34.9395 32.1035 35.0215 31.9199 35.1855 31.7754C35.3535 31.6191 35.5508 31.541 35.7773 31.541C36 31.541 36.1953 31.6191 36.3633 31.7754C36.5273 31.9199 36.6094 32.1035 36.6094 32.3262C36.6094 32.5449 36.5273 32.7285 36.3633 32.877C36.1914 33.0293 35.9961 33.1055 35.7773 33.1055Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_12313_361909",
    x: 56.4939,
    y: 54,
    width: 161.106,
    height: 44.7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12313_361909"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.45
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_12313_361909",
    result: "effect2_dropShadow_12313_361909"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_12313_361909",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_12313_361909",
    x: 7.8,
    y: 98.75,
    width: 168.306,
    height: 51.9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12313_361909"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_12313_361909",
    result: "effect2_dropShadow_12313_361909"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_12313_361909",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_12313_361909",
    x: 0.6,
    y: 1.75,
    width: 182.706,
    height: 66.3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12313_361909"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_12313_361909",
    result: "effect2_dropShadow_12313_361909"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_12313_361909",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12313_361909"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 230,
    height: 150,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.3a37d31d9fb661bae6f1e60b0ea6e0f8.svg";
export { ForwardRef as ReactComponent };